const state = {
    filters: {
        query: '',
        category: '',
        countryOfOrigin: '',
        countryOfUse: '',
        width: '',
        height: '',
        dimensionUnit: 'mt',
        weight: '',
        weightUnit: 'mt'
    },
};

const getters = {
};

const actions = {
    setFilters({commit}, payload) {
        commit('SET_FILTERS', payload);
    },

};

const mutations = {
    SET_FILTERS(state, data) {
        state.filters = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/search.js